/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {LOCALE_ID, NgModule, isDevMode } from '@angular/core';
// import { HttpModule, JsonpModule, BrowserXhr } from '@angular/common/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { StoreModule, ActionReducerMap, ActionReducer, MetaReducer } from '@ngrx/store';
import { StoreRouterConnectingModule, RouterStateSerializer, FullRouterStateSerializer } from '@ngrx/router-store';
import { EffectsModule } from '@ngrx/effects';
import { CoreModule } from './@core/core.module';
import { reducers, localStorageSyncReducer, metaReducers, } from '@app-stores/reducers';
import { AuthModule } from '@app-core/auth/auth.module';
import { AppService } from '@app-services/app.service';
import { AuthService } from '@app-services/auth.service';
import { TokenInterceptor } from "@app-services/http-interceptor";
import { CrmUsersService } from './pages/crm-users/crm-users.service';
import { CrmLanguagesService } from './pages/languages/crm-languages.service';
import { UsersService } from './pages/users/users.service';
import { CrmCommunityService } from './pages/communities/crm-community.service';
import { CrmGroupsService } from './pages/groups/crm-groups.service';
import { HttpHeaderService } from '@app-services/http-header.service';
import { TranslationService } from "@app-services/translation.service";
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { CanAccessDirective } from './directives/can-access.directive';
import { NbEvaIconsModule } from '@nebular/eva-icons/';
import {TrainingCommunityService} from "./pages/training-communities/training-community.service";
import { RouteReuseStrategy } from '@angular/router';
import {RouteReuseService} from './services/RouteReuseService';
import { NavigationService } from '@app-services/navigation.service';

@NgModule({
	declarations: [AppComponent, CanAccessDirective],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		// HttpModule,
		HttpClientModule,
		AppRoutingModule,
		StoreModule.forRoot(
			reducers,
			{
				metaReducers,

				// This is to prevent the entire app from crashing due to a startup error: Cannot add property __NG_ELEMENT_ID__, function is not extensible
				// https://stackoverflow.com/questions/66695786/angular-createcomponent-throws-error-typeerror-cannot-add-property
				runtimeChecks: {
					strictActionImmutability: false,
					strictActionSerializability: false,
					strictActionTypeUniqueness: false,
					strictActionWithinNgZone: false,
					strictStateImmutability: false,
					strictStateSerializability: false,
				}
			},
		),
		EffectsModule.forRoot([]),
		EffectsModule.forFeature([]),
		StoreRouterConnectingModule.forRoot({ serializer: FullRouterStateSerializer }),
		// NgbModule.forRoot(),
		ThemeModule.forRoot(),
		CoreModule.forRoot(),
		AuthModule,
		ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
		NbEvaIconsModule


	],
	bootstrap: [AppComponent],
	providers: [
		HttpHeaderService,
		AppService,
		AuthService,
		CrmUsersService,
		CrmLanguagesService,
		UsersService,
		CrmCommunityService,
		TrainingCommunityService,
		CrmGroupsService,
		TranslationService,
		NavigationService,
		// {provide: RouteReuseStrategy,
		// useClass:RouteReuseService},
		{ provide: APP_BASE_HREF, useValue: '/' },
		{ provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
		{
			provide: LOCALE_ID,
			deps: [TranslationService],
			useFactory: (TranslationService) => TranslationService.getLocale()  //returns locale string
		}
	],
	exports: [
		CanAccessDirective,

	]
})
export class AppModule {
}
